import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketMataInterface } from "@/types/suket_mata";
import SvcSuketMata from "@/services/SuketMata";
import { storePasien } from "@/store/modules/pasien";

@Module({ dynamic: true, namespaced: true, store, name: "suketmata" })
class SuketMata extends VuexModule {
  _suket: SuketMataInterface = null;
  _loading = false;

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  get suket(): SuketMataInterface {
    return this._suket;
  }

  get loading(): boolean {
    return this._loading;
  }

  get examInputCategory(): Array<any> {
    return [
      {
        id: "mata_sehat",
        name: "Mata sehat dan normal",
        type: "boolean",
        value: false
      },
      {
        id: "vod",
        name: "VOD",
        type: "string",
        value: null
      },
      {
        id: "vos",
        name: "VOS",
        type: "string",
        value: null
      },
      {
        id: "tak_buta_warna",
        name: "Tidak buta warna",
        type: "boolean",
        value: false
      }
    ];
  }

  @Mutation
  SET_SUKET(suket: SuketMataInterface) {
    this._suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this._loading = val;
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketMata.getByRegister(noReg).finally(() => {
      this.context.commit("SET_LOADING", false);
    });

    this.SET_SUKET(suketArray.data.length ? suketArray.data[0] : null);
  }
}

export default getModule(SuketMata);
